var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'pointer-events-none': !_vm.isEditable
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('blob-mask', {
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "has-mask": _vm.blob.mask,
      "blob-transform": _vm.blobTransform,
      "blob-mask-transform": _vm.blobMaskTransform,
      "blob-mask-relative-transform": _vm.blobMaskRelativeTransform
    }
  }, [_vm.showPrivacyScreen ? _c('div', {
    staticClass: "absolute-fill pointer-events-none overline short grey--text d-flex flex-column align-center justify-center privacy-screen"
  }, [_vm._v(" Private "), _c('v-btn', {
    staticStyle: {
      "pointer-events": "auto"
    },
    attrs: {
      "icon": "",
      "color": "grey"
    },
    on: {
      "click": _vm.showPrivate
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiHelpCircle)
    }
  })], 1)], 1) : _c('blob-frame', {
    class: {
      'pointer-events-none': !_vm.isEditable
    },
    style: {
      cursor: _vm.isEditable ? 'pointer' : 'inherit'
    },
    attrs: {
      "frame": _vm.frame,
      "frame-only": _vm.frameOnly
    },
    on: {
      "touchmove": function (e) {
        return !_vm.isEditable && e.preventDefault();
      }
    },
    nativeOn: {
      "mousedown": function ($event) {
        return _vm.move.apply(null, arguments);
      },
      "touchstart": function ($event) {
        return _vm.move.apply(null, arguments);
      }
    }
  }, [_vm.blob.type == 'TEXT' ? _c('text-blob', {
    ref: "text",
    attrs: {
      "blob": _vm.blob,
      "mode": _vm.mode,
      "is-editable": _vm.isEditable,
      "is-selected": _vm.isSelected,
      "is-transform-in-progress": !!_vm.transformInProgress,
      "virtual-keyboard": _vm.isShowingVirtualKeyboard
    },
    on: {
      "update:virtualKeyboard": function ($event) {
        _vm.isShowingVirtualKeyboard = $event;
      },
      "update:virtual-keyboard": function ($event) {
        _vm.isShowingVirtualKeyboard = $event;
      },
      "delete": function ($event) {
        return _vm.$emit('delete', true);
      },
      "loaded": function ($event) {
        return _vm.$emit('loaded');
      },
      "deselect": function ($event) {
        return _vm.$emit('deselect');
      },
      "click-text-event-link": function ($event) {
        return _vm.$emit('click-text-event-link');
      }
    }
  }) : _vm.blob.type == 'IMG' ? _c('image-blob', {
    attrs: {
      "blob": _vm.blob,
      "is-editable": _vm.isEditable,
      "is-preview": _vm.mode == 'preview',
      "is-selected": _vm.isSelected,
      "static": _vm.static
    },
    on: {
      "loaded": function ($event) {
        return _vm.$emit('loaded');
      }
    }
  }) : _vm.blob.type == 'VIDEO' ? _c('video-blob', {
    ref: "control-target",
    attrs: {
      "blob": _vm.blob,
      "is-owner": _vm.isPrimary,
      "is-card-owner": _vm.isCardOwner,
      "is-selected": _vm.isSelected,
      "is-page-active": _vm.isPageActive,
      "mode": _vm.mode,
      "scale": _vm.scale
    },
    on: {
      "delete": function ($event) {
        return _vm.$emit('delete', true);
      },
      "loaded": function ($event) {
        return _vm.$emit('loaded');
      }
    }
  }) : _vm.blob.type == 'GIFTCARD' ? _c('giftcard-blob', {
    attrs: {
      "blob": _vm.blob
    },
    on: {
      "loaded": function ($event) {
        return _vm.$emit('loaded');
      }
    }
  }) : _vm.blob.type == 'GROUP_VIDEO' ? _c('group-video-blob', {
    attrs: {
      "mode": _vm.mode,
      "blob": _vm.blob
    },
    on: {
      "loaded": function ($event) {
        return _vm.$emit('loaded');
      }
    }
  }) : _vm.blob.type == 'BTN' ? _c('btn-blob', {
    attrs: {
      "is-owner": _vm.isEditable,
      "blob": _vm.blob,
      "mode": _vm.mode
    },
    on: {
      "loaded": function ($event) {
        return _vm.$emit('loaded');
      }
    }
  }) : _vm._e()], 1)], 1), _vm.hasControls && !_vm.showPrivacyScreen ? _c('div', {
    staticClass: "absolute user-select-none",
    class: {
      'pointer-events-none': !_vm.isDraggingOnPage
    },
    staticStyle: {
      "z-index": "2"
    },
    style: _vm.blobMaskTransform || _vm.blobTransform,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.blob.type == 'BTN' ? _c('btn-blob-controls', {
    attrs: {
      "is-owner": _vm.isEditable,
      "blob": _vm.blob,
      "mode": _vm.mode
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click-btn');
      }
    }
  }) : _vm.blob.type == 'IMG' ? _c('image-mask-blob-controls', {
    attrs: {
      "user-id": _vm.userId,
      "blob": _vm.blob,
      "selected": _vm.selected,
      "mode": _vm.mode,
      "is-page-active": _vm.isPageActive,
      "is-dragging-on-page": _vm.isDraggingOnPage,
      "scale": _vm.scale
    },
    on: {
      "prompt-upload": function ($event) {
        _vm.select();

        _vm.$emit('prompt-upload-img');
      }
    }
  }) : _vm.blob.type == 'VIDEO' ? _c('video-blob-controls', {
    attrs: {
      "target": _vm.controlTarget,
      "static": _vm.static
    },
    on: {
      "play-video": function ($event) {
        return _vm.$emit('play-video');
      }
    }
  }) : _vm.blob.type == 'GIFTCARD' ? _c('giftcard-blob-controls', {
    attrs: {
      "blob": _vm.blob,
      "skin": _vm.skin,
      "is-owner": _vm.isPrimary,
      "is-card-owner": _vm.isCardOwner,
      "is-verified-recipient": _vm.isVerifiedRecipient,
      "scale": _vm.scale,
      "mode": _vm.mode
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click-giftcard');
      }
    }
  }) : _vm.blob.type == 'GROUP_VIDEO' ? _c('group-video-blob-controls', {
    attrs: {
      "blob": _vm.blob,
      "selected": _vm.selected,
      "is-owner": _vm.isPrimary,
      "scale": _vm.scale,
      "mode": _vm.mode
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click-group-video');
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.isSelected && (!_vm.isDraggingOnPage || _vm.transformInProgress == 'move') ? _c('div', {
    staticClass: "absolute pointer-events-none user-select-none",
    staticStyle: {
      "z-index": "3"
    },
    style: _vm.blobTransform
  }, [_c('blob-selection-controls', {
    staticClass: "absolute-fill",
    style: {
      margin: ("-" + (_vm.selectionControlsMargin) + "px")
    },
    attrs: {
      "blob": _vm.blob,
      "can-transform": _vm.canTransform,
      "is-primary": _vm.isPrimary,
      "mode": _vm.mode,
      "is-showing-virtual-keyboard": _vm.isShowingVirtualKeyboard
    },
    on: {
      "resize": _vm.resize,
      "rotate": _vm.rotate,
      "delete": function ($event) {
        return _vm.$emit('delete');
      },
      "update-text-event-link-disabled": function (v) {
        return _vm.$emit('update-text-event-link-disabled', v);
      }
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }